<template #resultPreviewContainer></template>
<div *ngIf="previewMode === 'popup' && showBar" class="preview-bar">
  <div *ngIf="this.fileType === 'pdf'" class="preview-bar-pages">
    Page <span class="preview-bar-page-num">{{ !!totalPages ? currentPage : '-' }}</span> /
    <span class="preview-bar-page-num">{{ !!totalPages ? totalPages : '-' }}</span>
  </div>

  <div class="preview-bar-action-container">
    <i
      (click)="zoomOut()"
      class="preview-bar-action font-icon icon-minus"
      [pTooltip]="'Zoom out'"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    >
    </i>
    <i
      (click)="resetZoom()"
      class="preview-bar-action font-icon icon-magnifier"
      [pTooltip]="'Reset'"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    >
    </i>
    <i
      (click)="zoomIn()"
      class="preview-bar-action font-icon icon-plus"
      [pTooltip]="'Zoom in'"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    >
    </i>
  </div>
</div>
